<template>
  <!-- 
    FIX: no-close-on-backdrop -> Orqa fonga bosganda yopilmaydi 
    FIX: no-close-on-esc -> ESC tugmasi bilan yopilmaydi
  -->
  <b-modal 
    :visible="value" 
    @change="val => $emit('input', val)"
    :title="itemData.id ? $t('Tahrirlash') : $t('Qo\'shish')" 
    hide-footer 
    centered 
    no-close-on-backdrop
    no-close-on-esc
  >
    <!-- Yuklanish holati -->
    <div v-if="loadingData" class="text-center py-5">
      <b-spinner variant="primary"></b-spinner>
      <p class="mt-3 text-muted">{{ $t("Ma'lumotlar yuklanmoqda...") }}</p>
    </div>

    <form v-else @submit.prevent="SaveData">
      <!-- Ism kiritish -->
      <div class="form-group">
        <label class="font-weight-bold text-secondary">{{ $t("Nomi") }}</label>
        <input v-model="form.name" type="text" class="form-control modern-input" required>
      </div>

      <!-- Rasm yuklash -->
      <div class="form-group mt-4">
        <label class="font-weight-bold text-secondary">{{ $t("Rasm") }}</label>
        <div class="image-upload-zone" :class="{ 'has-image': previewImage || form.image }"
          @click="$refs.fileInput.click()">
          <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none" accept="image/*" />

          <div v-if="!previewImage && !form.image" class="upload-placeholder text-center">
            <b-icon icon="cloud-upload" font-scale="3" class="mb-2 text-primary"></b-icon>
            <p class="mb-0 text-secondary small">{{ $t("Rasm yuklash uchun bosing") }}</p>
          </div>

          <div v-else class="upload-preview-container">
            <img :src="previewImage ? previewImage : getImagePath(form.image)" class="img-preview" />
            <div class="upload-overlay">
              <b-icon icon="camera" font-scale="2" class="text-white"></b-icon>
            </div>
          </div>
        </div>
        
        <div class="text-center mt-2" v-if="previewImage || form.image">
          <button type="button" class="btn btn-link text-danger btn-sm text-decoration-none" @click.stop="ClearImage()">
            <b-icon icon="trash"></b-icon> {{ $t("Rasmni o'chirish") }}
          </button>
        </div>
      </div>

      <!-- Footer tugmalari -->
      <div class="modal-custom-footer mt-4 pt-3 border-top">
        <button type="button" class="m-btn cancel-btn" @click="$emit('input', false)">
          {{ $t("Bekor qilish") }}
        </button>
        <button type="submit" class="m-btn save-btn" :disabled="saving">
          <b-spinner small v-if="saving" class="mr-1"></b-spinner>
          {{ saving ? $t('Saqlanmoqda...') : $t('Saqlash') }}
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false }, // Modal ochilishi uchun v-model
    itemData: { type: Object, default: () => ({ id: null }) } // Tahrirlash uchun ma'lumot
  },
  data() {
    return {
      form: { id: null, name: '', image: '' },
      previewImage: null,
      selectedFile: null,
      loadingData: false,
      saving: false
    };
  },
  watch: {
    // Modal ochilganda ishlaydi
    value(val) {
      if (val) {
        this.resetForm();
        if (this.itemData && this.itemData.id) {
          this.fetchDetail(this.itemData.id);
        }
      }
    }
  },
  methods: {
    resetForm() {
      this.form = { id: null, name: '', image: '' };
      this.previewImage = null;
      this.selectedFile = null;
      this.loadingData = false;
      this.saving = false;
    },
    async fetchDetail(id) {
      this.loadingData = true;
      try {
        const res = await axios.get(`api/v1/brand/id/${id}`);
        if (res.data) {
          this.form = { ...res.data };
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingData = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.previewImage = URL.createObjectURL(file);
      }
    },
    ClearImage() {
      this.selectedFile = null;
      this.previewImage = null;
      this.form.image = '';
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    getImagePath(imgName) {
      if (!imgName) return '';
      let baseUrl = (axios.defaults.baseURL || 'http://192.168.88.135:3000').replace(/\/$/, "");
      if (baseUrl.includes('/api/v1')) return `${baseUrl}/uploads/${imgName}`;
      return `${baseUrl}/api/v1/uploads/${imgName}`;
    },
    SaveData() {
      this.saving = true;
      let formData = new FormData();
      formData.append("name", this.form.name);
      if (this.selectedFile) formData.append("image", this.selectedFile);

      // Agar rasm o'chirilgan bo'lsa va yangisi yuklanmagan bo'lsa
      if (!this.form.image && !this.selectedFile && this.form.id) {
        // Backend logikasiga qarab bu yerda rasmni o'chirish logikasi bo'lishi mumkin
        // Masalan: formData.append("delete_image", true);
      }

      let url = this.form.id ? `api/v1/brand/id/${this.form.id}` : "api/v1/brand/";
      let method = this.form.id ? "patch" : "post";

      axios({ method, url, data: formData })
        .then(() => {
          this.$emit('saved'); // Ota komponentga muvaffaqiyatli saqlandi signalini berish
          this.$emit('input', false); // Modalni yopish
        })
        .catch(err => {
          console.error(err);
          this.$bvToast.toast(this.$t('Xatolik yuz berdi'), { variant: 'danger' });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style scoped>
/* Modal ichidagi stillar */
.modern-input {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 15px;
}
.image-upload-zone {
  width: 100%;
  height: 180px;
  border: 2px dashed #cbd5e0;
  border-radius: 15px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.img-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(161, 66, 244, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.3s;
}
.image-upload-zone:hover .upload-overlay {
  opacity: 1;
}
.modal-custom-footer {
  display: flex;
  gap: 10px;
}
.m-btn {
  flex: 1;
  padding: 12px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}
.cancel-btn {
  background: #f1f5f9;
  color: #64748b;
}
.save-btn {
  background: #a142f4;
  color: white;
}
</style>